import { IoCheckmarkCircle } from "react-icons/io5";
import Header from "./assist/Title";

export default function ConfirmPayment() {
  return (
    <>
      <div className="">
        <div>
          <Header />
          <div className="flex justify-center items-center">
            <div>
              <IoCheckmarkCircle className="text-green-500 w-20 h-20" />
              <p>
                Your Payment for Motor Vehicle Change Of Ownership was
                successful
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
